<template>
  <v-card
    outlined
    class="my-2"
    loader-height="8"
    :loading="admin.productSettingsLoading"
    :disabled="admin.productSettingsLoading"
    min-width="600"
    :min-height="minCardHeight"
  >
    <v-dialog v-model="showConfirmationDialog" max-width="450">
      <v-card>
        <v-card-title
          ><v-icon class="mr-2" color="yellow darken-2"> mdi-alert </v-icon
          >CONFIRM</v-card-title
        >
        <v-card-text class="text-h5"> Delete Setting ({{ id }})? </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="deleteProductSetting">
            <v-icon> mdi-check-bold </v-icon>
          </v-btn>
          <v-btn
            color="error lighten-1"
            @click="showConfirmationDialog = false"
          >
            <v-icon> mdi-cancel </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar color="blue lighten-2" class="text-h4 text-uppercase" dark>
      {{ tabName }}
      <v-spacer></v-spacer>

      <v-icon>{{ app.detailIcon }}</v-icon>
    </v-toolbar>
    <v-card-text v-show="admin.selectedProductSetting == null"></v-card-text>
    <v-card-text v-show="admin.selectedProductSetting != null">
      <v-overlay :opacity="0.9" absolute :value="showSaveOverlay">
        <v-btn color="success"> Setting saved </v-btn>
      </v-overlay>
      <v-form v-model="valid">
        <v-text-field disabled v-model="id" label="ID" readonly></v-text-field>
        <v-autocomplete
          :items="admin.attributeList"
          label="Attribute"
          outlined
          item-text="name"
          item-value="id"
          v-model="attributeId"
          :rules="validation.selection"
          autofocus
        ></v-autocomplete>
        <v-text-field
          v-model="label"
          :rules="validation.length50"
          label="Label"
          required
        ></v-text-field>
        <v-text-field v-model="valueSuffix" label="Value Suffix"></v-text-field>
        <v-textarea
          outlined
          v-model="sigMessage"
          label="Sig Message"
        ></v-textarea>
        <v-checkbox
          color="blue darken-2"
          v-model="published"
          label="Published"
        ></v-checkbox>
      </v-form>
    </v-card-text>
    <v-card-actions v-show="admin.selectedProductSetting != null">
      <v-spacer />
      <v-btn
        dark
        color="blue darken-2"
        @click="saveProductSetting"
        :disabled="!valid"
        >save</v-btn
      >
      <v-btn color="gray" @click="cancelCreation">cancel</v-btn>
      <v-btn
        v-show="!isNaN(id)"
        icon
        color="error"
        @click="confirmDeleteSetting"
        ><v-icon>mdi-trash-can</v-icon></v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      minCardHeight: Number
    },
    components: {},
    data() {
      return {
        showSaveOverlay: false,
        showConfirmationDialog: false,
        valid: false
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      tabName: {
        get() {
          let tabName = 'Edit';
          if (
            this.admin.selectedProductSetting &&
            this.admin.selectedProductSetting.id != 'new'
          ) {
            tabName = `Edit Setting ${this.admin.selectedProductSetting.label}`;
          } else if (
            this.admin.selectedProductSetting &&
            this.admin.selectedProductSetting.id == 'new'
          ) {
            tabName = 'Add New Setting';
          }
          return tabName;
        }
      },
      id: {
        get() {
          return this.admin.selectedProductSetting?.id;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductSetting',
            property: 'id',
            value: value
          });
        }
      },
      productId: {
        get() {
          return this.admin.selectedProductSetting?.productId;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductSetting',
            property: 'productId',
            value: Number(value)
          });
        }
      },
      attributeId: {
        get() {
          return this.admin.selectedProductSetting?.attributeId;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductSetting',
            property: 'attributeId',
            value: Number(value)
          });
        }
      },
      label: {
        get() {
          return this.admin.selectedProductSetting?.label;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductSetting',
            property: 'label',
            value: value
          });
        }
      },
      valueSuffix: {
        get() {
          return this.admin.selectedProductSetting?.valueSuffix;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductSetting',
            property: 'valueSuffix',
            value: value
          });
        }
      },
      sigMessage: {
        get() {
          return this.admin.selectedProductSetting?.sigMessage;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductSetting',
            property: 'sigMessage',
            value: value
          });
        }
      },
      published: {
        get() {
          return this.admin.selectedProductSetting?.published;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductSetting',
            property: 'published',
            value: Boolean(value)
          });
        }
      }
    },
    methods: {
      /**
       * Cancels upsert of a product
       */
      cancelCreation() {
        this.$store.commit('admin/setSelectedProductSetting', null);
      },
      /**
       * Saves the product currently being edited
       */
      saveProductSetting() {
        this.$store.dispatch('admin/saveSelectedProductSetting').then(() => {
          this.showSaveOverlay = true;
          // refresh product list
          this.$store.dispatch('admin/getProductSettingList');
          setTimeout(() => {
            this.showSaveOverlay = false;
            this.$store.commit('admin/setSelectedProductSetting', null);
          }, 1500);
        });
      },
      /**
       * Show confirm dialog
       */
      confirmDeleteSetting() {
        this.showConfirmationDialog = true;
      },
      /**
       * Deletes a a product setting
       */
      deleteProductSetting() {
        this.$store.dispatch('admin/deleteProductSetting', this.id).then(() => {
          this.$store.dispatch('admin/getProductSettingList');
          this.showConfirmationDialog = false;
          this.$store.commit('admin/setSelectedProductSetting', null);
        });
      }
    }
  };
</script>

<style scoped></style>
